import React from 'react'
import BlogPostCard from './blogPostCard'

import { PostDataType } from '@/types'
import styles from './blogPost.module.scss'

export const BlogPost = ({ posts }: { posts: PostDataType[] }) => {
  return (
    <div className={styles.card}>
      {posts?.map((p) => <BlogPostCard post={p} key={p.id} />).slice(0, 4)}
    </div>
  )
}

export default BlogPost
